const util = {
  /**
   * 格式化时间
   * @param time : Object | String | Number
  */
  formatTime(time, formatType) {
    let date = null
    const type = time ? typeof time : null
    if (type == 'object') {
      date = time
    } else {
      date = time ? new Date(time) : new Date()
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds()
    }
    const format = formatType || '{y}.{m}.{d}'
    const time_str = format.replace(/{([mdyhis])+}/g, (result, key) => {
      const value = formatObj[key]
      return value.toString().padStart(2, '0')
    })
    return time_str
  },
  /**
   * 当天显示{h}:{i}
   * 之前时间显示{m}月{d}日
   * 过去几年显示{y}年{m}月{d}日
   * @param {String||Number} time
   */
  formatTime2(time) {
    const curDate = new Date()
    let date = null // 传入的时间对象
    const type = time ? typeof time : null
    if (type == 'object') {
      date = time
    } else {
      date = time ? new Date(time) : new Date()
    }
    let str = ''
    if (new Date(curDate.toLocaleDateString()).getTime() === new Date(date.toLocaleDateString()).getTime()) { // 今天
      str = util.formatTime(time, '{h}:{i}')
    } else if (curDate.getFullYear() > date.getFullYear()) {
      str = util.formatTime(time, '{y}年{m}月{d}日')
    } else {
      str = util.formatTime(time, '{m}月{d}日')
    }
    return str
  },
  /**
   * 格式化千位符
   * @param str: String | Number
   */
  formatAmount(str) { // 金额千位格式化
    if (Number(str) !== 0 && !str) return '--'
    if (isNaN(str)) return 'NaN'
    let unit = ''
    if (str < 0) {
      unit = '-'
    }
    const str1 = String(Math.abs(str)).split('.')
    str = str1[0]
    const strArr = String(str).split('').reverse()
    let strFin = ''
    for (let i = 1; i <= strArr.length; i++) {
      strFin = strFin + strArr[i - 1]
      if (i % 3 === 0) {
        strFin = strFin + ','
      }
    }
    const arr = strFin.split('').reverse()
    if (arr[0] === ',') {
      arr.shift()
    }
    if (!arr.length) {
      return 0
    }
    const regNum = /e/i
    if (regNum.test(str)) { // 处理科学计数法中的小数位数太多问题
      return unit + (parseInt(str) + str.match(/e\d+$/i)[0])
    }

    if (str1[1]) {
      return unit + arr.join('') + '.' + str1[1]
    }
    return unit + arr.join('')
  },
  /**
   * 将数字格式化位千、万、亿
  * @param number
  */
  formatNumber(number) {
    if (typeof +number !== 'number') return '--'
    if (number < 10000) {
      return number
    } else if (number >= 10000 && number < 10000000) {
      return (number / 10000).toFixed(2) + 'w'
    } else if (number >= 10000000) {
      return (number / 10000000).toFixed(2) + 'kw'
    }
  }

}


export default util

